import { render, staticRenderFns } from "./processedSeller.vue?vue&type=template&id=4f0541f4&scoped=true&"
import script from "./processedSeller.vue?vue&type=script&lang=js&"
export * from "./processedSeller.vue?vue&type=script&lang=js&"
import style0 from "./processedSeller.vue?vue&type=style&index=0&id=4f0541f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0541f4",
  null
  
)

export default component.exports